import { render, staticRenderFns } from "./CreateTableDropDownTwo.vue?vue&type=template&id=6ef335c6&scoped=true&"
import script from "./CreateTableDropDownTwo.vue?vue&type=script&lang=js&"
export * from "./CreateTableDropDownTwo.vue?vue&type=script&lang=js&"
import style0 from "./CreateTableDropDownTwo.vue?vue&type=style&index=0&id=6ef335c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef335c6",
  null
  
)

export default component.exports